import React, { useEffect, useState, useRef } from "react";
import {
  Tooltip,
  makeStyles,
  Avatar,
  TableCell,
  TableRow,
  TableCellLayout,
  PopoverTrigger,
  Popover,
  PopoverSurface,
} from "@fluentui/react-components";
import { useHistory } from "react-router-dom";
import useNavigation from "../../../../../utils/useNavigation";
import {
  FlagIcon,
  FlaggedIcon,
  MeatBallsMenuIcon,
  PendingDeleteIcon,
  PlusIcon,
} from "../../../../../modules/default-svg";
import HoverCard from "../../../../hoverCard/HoverCard";
import {
  dateOnlyFormatted,
  getAccountCurrency,
  displayDecimalFormatted,
} from "../../../../../utils/systemSettings";
import CustomInput from "../../../input/customInput/CustomInput";
import service from "../../../../../store/services/user.service";
import CustomSelect from "../../../select/CustomSelect";
import userService from "../../../../../store/services/user.service";
import { useDispatch } from "react-redux";
import { generalActions } from "../../../../../store/actions";
import { apiCall } from "../../../../../store/services/service";
import {
  BASE_URL,
  URL_SEARCH_CLIENT_PORTFOLIO,
} from "../../../../../store/services/URL";
import {
  createProjectRequest,
  updateProjectRequest,
} from "../../../../../store/actions/projects.actions";
import { getLabelByType, projectStatus } from "../../../../../helpers/utils";
import DropDown from "../../../dropdown/DropdownFluent";

const useStyles = makeStyles({
  tooltip: {
    backgroundColor: "#342c82",
    color: "#FFFFFF",
  },
});

const ProjectRow = (props) => {
  const {
    item,
    sortingCriteria,
    data,
    handleModal,
    updateStatus,
    updateProjectStatus,
    menu,
    sortProjectRequest,
    parentType,
    projectId,
    portfolioId,
    clientId,
    programId,
    updateFlag,
    columnConfig,
  } = props;
  const settings = JSON.parse(localStorage.getItem("settings"));
  const [clients, setClients] = useState([]);
  const [resources, setResources] = useState([]);
  const [ownerId, setOwnerId] = useState("");
  const [programs, setPrograms] = useState([]);
  const [flagged, setFlagged] = useState([]);
  const [sortedData, setSortedData] = useState([]);
  const [popoverOpen, setPopoverOpen] = useState({});
  const [setting] = useState(settings);
  const history = useHistory();
  const { navigateTo } = useNavigation();
  const popoverRef = useRef(null);
  const projectNameInputRef = useRef(null);
  const clientInputRef = useRef(null);
  const programInputRef = useRef(null);
  const managerInputRef = useRef(null);
  const budgetInputRef = useRef(null);
  const startDateInputRef = useRef(null);
  const endDateInputRef = useRef(null);
  const portfolioInputRef = useRef(null);
  const phaseInputRef = useRef(null);
  const statusInputRef = useRef(null);
  const dispatch = useDispatch();

  const [portfolioOptions, setPortfolioOptions] = useState([]);
  const [isEditRecord, setIsEditRecord] = useState(null);
  const [formErrors, setFormErrors] = useState({
    name: "",
  });

  const handleBlur = () => {
    let data = { ...isEditRecord.name };
    if (data.client) {
      data.clientId = data.client.id;
    } else {
      data.clientId = null;
    }
    if (data.portfolio) {
      data.portfolioId = data.portfolio.id;
    } else {
      data.portfolioId = null;
    }
    if (data.program) {
      data.programId = data.program.id;
    } else {
      data.programId = null;
    }
    if (data.owner) {
      data.ownerId = data.owner.id;
    } else {
      data.ownerId = null;
    }
    const payload = {};
    payload.parent = "Project";
    if (parentType === "Client") {
      payload.parentId = clientId;
      payload.parent = "Client";
      data.clientId = clientId;
    }
    if (parentType === "Program") {
      payload.parentId = programId;
      payload.parent = "Program";
      data.programId = programId;
    }
    if (parentType === "Portfolio") {
      payload.parentId = portfolioId;
      payload.parent = "Portfolio";
      data.portfolioId = portfolioId;
    }

    if (data.name && data.clientId) {
      if (data?.id) {
        dispatch(
          updateProjectRequest({
            id: sortedData[isEditRecord.index].id,
            payload: data,
            ...payload,
          })
        );
      } else {
        dispatch(createProjectRequest({ payload: data, ...payload }));
      }
      setIsEditRecord(null);
    } else {
      const errors = {};
      if (!data.name) {
        errors["name"] = `The Name field is required.`;
        dispatch(
          generalActions.showToast({
            title: "name is a required field",
            type: "error",
          })
        );
      } else if (!data.client) {
        errors["client"] = "Client is a required Field";

        dispatch(
          generalActions.showToast({
            title: "Client is a required field",
            type: "error",
          })
        );
      }
      setFormErrors(errors);
    }
  };

  const handleEditable = (event) => {
    if (event.key === "Escape") {
      setIsEditRecord(null);
    } else if (event.key === "Enter") {
      if (isEditRecord) {
        handleBlur();
      }
    }
  };

  useEffect(() => {
    if (sortingCriteria.column !== null) {
      if (
        parentType === "Client" ||
        parentType === "Program" ||
        parentType === "Portfolio"
      ) {
        sortProjectRequest({
          id:
            parentType === "Client"
              ? clientId
              : parentType === "Program"
              ? projectId
              : portfolioId,
          parent: parentType,
          page: 1,
          size: 10,
          orderBy: `${sortingCriteria.column} ${sortingCriteria.order}`,
        });
      } else {
        sortProjectRequest({
          parent: parentType,
          page: 1,
          size: 10,
          orderBy: `${sortingCriteria.column} ${sortingCriteria.order}`,
        });
      }
    }
  }, [sortingCriteria]);

  useEffect(() => {
    if (updateStatus) {
      updateProjectStatus({
        id: item.id,
        payload: [
          {
            op: "replace",
            path: "/isActive",
            value: !item.isActive,
          },
        ],
      });
    }
  }, [updateStatus]);

  useEffect(() => {
    if (typeof data != "string") {
      data
        .filter((d) => d.isFlagged)
        .map((f) => {
          if (!flagged.includes(f.id)) {
            setFlagged((prevItems) => [...prevItems, f.id]);
          }
        });
      const tempData = [...data];
      tempData.push({
        name: "",
        startDate: "",
        endDate: "",
        program: null,
        client: null,
        portfolio: null,
        owner: null,
        status: 0,
        budget: 0,
      });
      setSortedData(tempData);
    }
  }, [data]);

  const handleRedirect = (item) => {
    // Use navigation hook instead of localStorage
    navigateTo("Projects", item.id, item.name);
  };

  const handleRedirectClient = (item) => {
    if (parentType !== "Client") {
      // Use navigation hook for direct navigation to client
      navigateTo("Clients", item.client.id, item.client.name);
    } else {
      // Already in client context, just navigate
      history.push(`/clients/${item.client.id}/overview`);
    }
  };

  const handlePortfolioRedirect = (item) => {
    if (parentType !== "Portfolio") {
      // Use navigation hook for direct navigation to portfolio
      navigateTo(
        "Portfolios",
        item.portfolio.id,
        item.portfolio.name
      );
    } else {
      // Already in portfolio context, just navigate
      history.push(`/portfolio/${item.portfolio.id}/overview`);
    }
  };

  const handleRedirectProgram = (item) => {
    if (item.program) {
      if (parentType !== "Program") {
        // Use navigation hook for direct navigation to program
        navigateTo("Programs", item.program.id, item.program.name);
      } else {
        // Already in program context, just navigate
        history.push(`/program/${item.program.id}/overview`);
      }
    }
  };

  useEffect(() => {
    if (menu.props.closePopover) {
      setPopoverOpen(null);
    }
  }, [menu.props.closePopover]);

  const handlePopoverOpen = (rowId) => {
    setPopoverOpen(rowId);
  };

  const handleClickOutside = (event) => {
    if (
      popoverRef.current &&
      !popoverRef.current.contains(event.target) &&
      event.target?.innerText !== "Edit" &&
      event.target?.innerText !== "Delete" &&
      event.target?.innerText !== "Remind me" &&
      event?.target?.tagName !== "svg"
    ) {
      if (popoverOpen) {
        handlePopoverOpen(null);
      }
    }
    if (
      isEditRecord &&
      event.target.localName !== "input" &&
      event.target.localName !== "div" &&
      event.target.className && // Ensure className exists
      typeof event.target.className === "string" && // Ensure className is a string
      !event.target.className.includes("fui-Dropdown__button")
    ) {
      handleBlur();
    } else if (isEditRecord && event.target.placeholder === "Search") {
      handleBlur();
    }
  };

  const handleScroll = (e) => {
    handlePopoverOpen(null);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("wheel", handleScroll);
    document.addEventListener("keydown", handleEditable);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("wheel", handleScroll);
      document.removeEventListener("keydown", handleEditable);
    };
  }, [isEditRecord, popoverOpen]);

  const searchClientHandler = (value) => {
    if (value === "") {
      setClients([]);
      return;
    }
    // if (value) {
    service
      .searchClientDataRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setClients(transformedArray);
      })
      .catch(() => {
        setClients([]);
      });
    // }
  };

  const searchHandler = (value) => {
    if (value === "") {
      setResources([]);
      return;
    }
    userService
      .searchUserDataRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setResources(transformedArray);
      })
      .catch(() => {
        setResources([]);
      });
  };

  ///////////////////////// FLAGGED fUNCTIONALITY /////////////////////////

  const handleInputChange = (value, type) => {
    let error = { ...formErrors };
    const data = JSON.parse(JSON.stringify(isEditRecord));
    if (type === "name") {
      error["name"] = "";
      setFormErrors(error);
      data.name.name = value;
      setIsEditRecord(data);
    } else if (type === "client") {
      if (!value) {
        data.name.client = null;
      } else {
        if (!data.name?.client) {
          data.name.client = {};
        }
        data.name.client.name = value.label;
        data.name.client.id = value.value;
      }
      data.name.project = null;
      data.name.portfolio = null;
      data.name.program = null;
      setIsEditRecord(data);
    } else if (type === "portfolio") {
      if (!value) {
        data.name.portfolio = null;
      } else {
        if (!data.name?.portfolio) {
          data.name.portfolio = {};
        }
        data.name.portfolio.name = value.label;
        data.name.portfolio.id = value.value;
      }
      data.name.program = null;
      data.name.project = null;
      setIsEditRecord(data);
    } else if (type === "program") {
      if (!value) {
        data.name.program = null;
      } else {
        if (!data.name?.program) {
          data.name.program = {};
        }
        data.name.program.name = value.label;
        data.name.program.id = value.value;
      }
      data.name.project = null;
      setIsEditRecord(data);
    } else if (type === "manager") {
      if (value) {
        if (!data?.name?.owner) {
          data.name.owner = {};
        }
        data.name.owner.name = value.label;
        data.name.owner.id = value.value;
      } else {
        data.name.owner = null;
      }
      setIsEditRecord(data);
    } else if (type === "status") {
      data.name.status = value;
      setIsEditRecord(data);
    } else if (type === "phase") {
      data.name.phase = value;
      setIsEditRecord(data);
    } else if (type === "budget") {
      data.name.budget = value;
      setIsEditRecord(data);
    } else if (type === "startDate") {
      data.name.startDate = value;
      setIsEditRecord(data);
    } else if (type === "endDate") {
      data.name.endDate = value;
      setIsEditRecord(data);
    }
  };

  const addFlag = (id) => {
    setFlagged((prevItems) => [...prevItems, id]);
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: true,
        },
      ],
    });
  };

  const removeFlag = (id) => {
    setFlagged((prevItems) => prevItems.filter((item) => item !== id));
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: false,
        },
      ],
    });
  };

  useEffect(() => {
    const sortedArray = data;
    const tempData = [...sortedArray];
    tempData.push({
      name: "",
      startDate: "",
      endDate: "",
      program: null,
      client: null,
      portfolio: null,
      owner: null,
      status: 0,
      budget: 0,
    });
    setSortedData(tempData);
  }, [flagged]);

  const sortDataByFlagged = (dataArray, flaggedArray) => {
    const flaggedItems = [];
    const remainingItems = [];

    dataArray.forEach((item) => {
      if (flaggedArray.includes(item.id)) {
        flaggedItems.push(item);
      } else {
        remainingItems.push(item);
      }
    });

    flaggedItems.sort((a, b) => {
      return flaggedArray.indexOf(a.id) - flaggedArray.indexOf(b.id);
    });

    return [...flaggedItems, ...remainingItems];
  };

  const searchProgramHandler = (value) => {
    if (value === "") {
      setPrograms([]);
      return;
    }
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;

    payload.parent = "Project";

    if (isEditRecord?.name?.client) {
      queryParam = `?clientId=${isEditRecord?.name?.client?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.portfolio) {
      queryParam = `?portfolioId=${isEditRecord?.name?.portfolio.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.client && isEditRecord?.name?.portfolio) {
      queryParam = `?clientId=${isEditRecord?.name?.client.id}&portfolioId=${isEditRecord?.name?.portfolio.id}&searchTerm=${payload.searchText}`;
    }

    if (parentType === "Portfolio") {
      queryParam = queryParam + `&portfolioId=${portfolioId}`;
    }

    apiCall
      .get({ url: `${BASE_URL}search/Programs${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setPrograms(transformedArray);
      })
      .catch(() => {
        setPrograms([]);
      });
  };

  const searchPortfolioHandler = (value) => {
    if (value === "") {
      setPortfolioOptions([]);
      return;
    }
    const payload = { id: isEditRecord?.name?.client?.id, searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    if (isEditRecord?.name?.client)
      queryParam = `?clientId=${payload.id}&searchTerm=${payload.searchText}`;
    apiCall
      .get({
        url: `${URL_SEARCH_CLIENT_PORTFOLIO}${queryParam}`,
        isAuthToken: true,
      })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setPortfolioOptions(transformedArray);
      })
      .catch(() => {
        setPortfolioOptions([]);
      });
  };
  const handleIsEdiRecord = (index, type) => {
    if (index === data.length && type !== "name") {
      sortedData[index] = {
        ...isEditRecord?.name,
      };
    }
    if (isEditRecord && isEditRecord.index === index) {
      focusField(type);
      return;
    }
    setIsEditRecord({ index: index, name: sortedData[index] });
    setTimeout(() => {
      focusField(type);
    }, 0);
  };

  const focusField = (type) => {
    switch (type) {
      case "name":
        programInputRef.current?.focus();
        break;
      case "client":
        clientInputRef.current?.focus();
        break;
      case "program":
        programInputRef.current?.focus();
        break;
      case "portfolio":
        portfolioInputRef.current?.focus();
        break;
      case "budget":
        budgetInputRef.current?.focus();
        break;
      case "phase":
        phaseInputRef.current?.focus();
        break;
      case "status":
        statusInputRef.current?.focus();
        break;
      case "project":
        projectNameInputRef.current?.focus();
        break;
      case "manager":
        managerInputRef.current?.focus();
        break;
      case "startDate":
        startDateInputRef.current?.focus();
        break;
      case "endDate":
        startDateInputRef.current?.focus();
        break;
      default:
        break;
    }
  };

  ///////////////////////// FLAGGED fUNCTIONALITY /////////////////////////
  // Sort columnConfig by order
  const sortedColumnConfig = [...columnConfig].sort(
    (a, b) => a.order - b.order
  );

  const renderTableCell = (item, index, column) => {
    const isEditing = isEditRecord && isEditRecord.index === index;

    switch (column.label) {
      case "Project":
        return (
          <TableCell className={isEditing ? "" : "hoverCell"}>
            <div className="d-flex justify-content-between inputWidth">
              <div className="d-flex align-items-center inputWidth">
                {item?.id && (
                  <Tooltip
                    positioning="before"
                    content={{
                      children: flagged.includes(item.id) ? "Unflag" : "Flag",
                      className: styles.tooltip,
                    }}
                    relationship="label"
                    withArrow
                  >
                    <span
                      className={`flag ${
                        flagged.includes(item.id) ? "flagActive" : ""
                      }`}
                      onClick={() =>
                        flagged.includes(item.id)
                          ? removeFlag(item.id)
                          : addFlag(item.id)
                      }
                    >
                      <FlagIcon />
                    </span>
                  </Tooltip>
                )}
                {isEditing ? (
                  <CustomInput
                    inputwd="inputWidth me-3"
                    icon={false}
                    placeholder="Add project name"
                    value={isEditRecord.name.name}
                    type="text"
                    handleChange={(value) => handleInputChange(value, "name")}
                    ref={projectNameInputRef}
                    errorMessage={formErrors.name}
                    displayErrorMessage={false}
                  />
                ) : item?.id ? (
                  <span
                    className="d-flex w-full text-truncate"
                    onClick={() => handleRedirect(item)}
                  >
                    {item.isPendingDelete && <div className="mr-1"><PendingDeleteIcon/></div>}
                    {item.name}
                  </span>
                ) : (
                  <div
                    className="d-flex _add_btn"
                    onClick={() =>
                      handleIsEdiRecord(sortedData.length - 1, "name")
                    }
                  >
                    <PlusIcon />
                    Add
                  </div>
                )}
              </div>
              {item?.id && (
                <div className="flag">
                  <Popover
                    {...props}
                    open={popoverOpen === item.id}
                    onOpenChange={(isOpen) =>
                      isOpen && handlePopoverOpen(item.id)
                    }
                    positioning="below-start"
                  >
                    <PopoverTrigger disableButtonEnhancement>
                      <TableCellLayout
                        media={<MeatBallsMenuIcon />}
                        onClick={() => handleModal(item)}
                      />
                    </PopoverTrigger>
                    <PopoverSurface
                      tabIndex={-1}
                      className="listingPopoverWrapper"
                    >
                      {menu}
                    </PopoverSurface>
                  </Popover>
                </div>
              )}
            </div>
          </TableCell>
        );
      case "Client":
        if (parentType === "Client") return null;
        return (
          <TableCell
            onClick={() => handleIsEdiRecord(index, "client")}
            className={isEditing ? "" : "hoverCell"}
          >
            {isEditing ? (
              <CustomSelect
                SelectText="client"
                searchText={searchClientHandler}
                options={clients}
                defaultVal={
                  isEditRecord.name.client
                    ? {
                        label: isEditRecord.name.client.name,
                        value: isEditRecord.name.client.id,
                      }
                    : null
                }
                onChange={(e) => handleInputChange(e, "client")}
                CustomClass="ModalAvatarSearch"
              />
            ) : (
              <span onClick={() => handleRedirectClient(item)}>
                {item?.client?.name || ""}
              </span>
            )}
          </TableCell>
        );
      case "Portfolio":
        return isEditing ? (
          <TableCell className={isEditing ? "" : "hoverCell"}>
            <CustomSelect
              CustomClass="ModalAvatarSearch"
              persona={true}
              searchText={searchPortfolioHandler}
              SelectText="portfolio"
              options={portfolioOptions}
              defaultVal={
                isEditRecord.name.portfolio?.name
                  ? {
                      label: isEditRecord.name.portfolio.name,
                      value: isEditRecord.name.portfolio.id,
                    }
                  : null
              }
              onChange={(e) => handleInputChange(e, "portfolio")}
            />
          </TableCell>
        ) : item.portfolio ? (
          <TableCell
            className={isEditing ? "" : "hoverCell"}
            onClick={() => handleIsEdiRecord(index, "portfolio")}
          >
            <span onClick={() => handlePortfolioRedirect(item)}>
              {item.portfolio?.name}
            </span>
          </TableCell>
        ) : (
          <TableCell onClick={() => handleIsEdiRecord(index, "portfolio")} />
        );
      case "Program":
        return (
          <TableCell
            onClick={() => handleIsEdiRecord(index, "program")}
            className={isEditing ? "" : "hoverCell"}
          >
            {isEditing ? (
              <CustomSelect
                SelectText="program"
                searchText={searchProgramHandler}
                options={programs}
                defaultVal={
                  isEditRecord.name.program?.name
                    ? {
                        label: isEditRecord.name.program.name,
                        value: isEditRecord.name.program.id,
                      }
                    : null
                }
                onChange={(e) => handleInputChange(e, "program")}
                CustomClass="ModalAvatarSearch"
              />
            ) : (
              <span onClick={() => handleRedirectProgram(item)}>
                {item.program ? item.program.name : ""}
              </span>
            )}
          </TableCell>
        );
      case "Project Manager":
        return (
          <TableCell
            role="gridcell"
            onClick={() => handleIsEdiRecord(index, "manager")}
          >
            {isEditing ? (
              <CustomSelect
                SelectText="manager"
                searchText={searchHandler}
                options={resources}
                defaultVal={
                  isEditRecord.name.owner?.name
                    ? {
                        label: isEditRecord.name.owner.name,
                        value: isEditRecord.name.owner.id,
                      }
                    : null
                }
                onChange={(e) => handleInputChange(e, "manager")}
                creatable={true}
                setCreated={setOwnerId}
                CustomClass="ModalAvatarSearch"
              />
            ) : item.owner ? (
              <TableCellLayout
                media={
                  <HoverCard
                    HoverCardTrigger={
                      <Avatar
                        color="colorful"
                        name={item.owner ? item.owner.name : ""}
                        image={{
                          src: item.owner.image ? item.owner.image : "",
                        }}
                      />
                    }
                    AvatarId={item.owner?.id}
                    AvatarName={item.owner?.name}
                    AvatarImage={item.owner?.image}
                    AvatarDesignation={item.owner?.title}
                    AvatarEmail={item.owner?.email}
                    AvatarPhone={item.owner?.phoneNumber}
                    AvatarIsExternal={item.owner?.isExternal}
                  />
                }
              >
                {item.owner ? item.owner.name : ""}
              </TableCellLayout>
            ) : (
              ""
            )}
          </TableCell>
        );
      case "Status":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "status")}>
            <p className={isEditing ? "" : !item?.id ? "" : "pill blue"}>
              {isEditing ? (
                <DropDown
                  label="Status"
                  showLabel={false}
                  options={projectStatus}
                  defaultVal={isEditRecord.name.status}
                  onChange={(e) => handleInputChange(e, "status")}
                  isInlineFocus={true}
                />
              ) : (
                item?.id && getLabelByType("project", item.status)
              )}
            </p>
          </TableCell>
        );
      case "Phase":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "phase")}>
            {isEditing ? (
              <CustomInput
                inputwd="inputWidth me-3"
                icon={false}
                placeholder="Enter phase"
                value={isEditRecord.name.phase}
                type="text"
                handleChange={(value) => handleInputChange(value, "phase")}
                ref={phaseInputRef}
              />
            ) : (
              item.phase
            )}
          </TableCell>
        );
      case "Budget":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "budget")}>
            {isEditing ? (
              <CustomInput
                inputwd="inputWidth me-3"
                icon={false}
                placeholder="0"
                type="number"
                currency={true}
                inline={true}
                value={isEditRecord.name.budget}
                handleChange={(value) => handleInputChange(value, "budget")}
                ref={budgetInputRef}
              />
            ) : item?.id ? (
              `${getAccountCurrency(setting)} ${displayDecimalFormatted(
                setting,
                item.budget
              )}`
            ) : (
              ""
            )}
          </TableCell>
        );
      case "Actual":
        return (
          <TableCell>
            {item?.id
              ? `${getAccountCurrency(setting)} ${displayDecimalFormatted(
                  setting,
                  item.actual
                )}`
              : ""}
          </TableCell>
        );
      case "Accural":
        return (
          <TableCell>
            {item?.id
              ? `${getAccountCurrency(setting)} ${displayDecimalFormatted(
                  setting,
                  item.accural
                )}`
              : ""}
          </TableCell>
        );
      case "ETC":
        return (
          <TableCell>
            {item?.id
              ? `${getAccountCurrency(setting)} ${displayDecimalFormatted(
                  setting,
                  item.etc
                )}`
              : ""}
          </TableCell>
        );
      case "BAC":
        return (
          <TableCell>
            {item?.id
              ? `${getAccountCurrency(setting)} ${displayDecimalFormatted(
                  setting,
                  item.bac
                )}`
              : ""}
          </TableCell>
        );
      case "Start Date":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "startDate")}>
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.startDate}
                type="date"
                handleChange={(value) => handleInputChange(value, "startDate")}
                ref={startDateInputRef}
              />
            ) : item.startDate ? (
              dateOnlyFormatted(setting, item.startDate)
            ) : (
              ""
            )}
          </TableCell>
        );
      case "End Date":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "endDate")}>
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.endDate}
                type="date"
                handleChange={(value) => handleInputChange(value, "endDate")}
                ref={endDateInputRef}
              />
            ) : item.endDate ? (
              dateOnlyFormatted(setting, item.endDate)
            ) : (
              ""
            )}
          </TableCell>
        );
      default:
        return null;
    }
  };

  const styles = useStyles();
  return sortedData.map((item, index) => (
    <TableRow key={item.id || index} className="ProjectHover" ref={popoverRef}>
      {sortedColumnConfig
        .filter((col) => col.isVisible)
        .filter((col) => parentType !== "Client" || col.label !== "Client")
        .filter(
          (col) => parentType !== "Portfolio" || col.label !== "Portfolio"
        )
        .filter((col) => parentType !== "Program" || col.label !== "Program")
        .filter((col) => col.isVisible)
        .map((col) => (
          <TableCell key={col.label}>
            {renderTableCell(item, index, col)}
          </TableCell>
        ))}
    </TableRow>
  ));
};

export default ProjectRow;
